import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  EmployeeContactRole,
  IEmployeeContact,
} from "../interfaces/IEmployeeContact";
import ApiCacheService from "./apiCacheService";
import { ApiEndpointResolver } from "./apiEndpointResolver";
import HttpClient from "./httpClient";

export const ContactsService = {
  getArContact(): Observable<{
    name: string;
    email: string;
    phone: string;
    imageUrl: string;
  }> {
    if (ApiEndpointResolver.getEmployeeContactsUrl()) {
      return this.getEmployeeContacts().pipe(
        map((contacts: IEmployeeContact[]) => {
          return contacts
            .filter((c) => c.employeeContactRole === EmployeeContactRole.Ar)
            .map((contact) => {
              return {
                name: contact.name,
                email: contact.email,
                phone: contact.phone,
                imageUrl: contact.imageUrl,
              };
            })[0];
        })
      );
    } else {
      return ApiCacheService.withCache(
        "ARContact",
        HttpClient.get({
          baseUri: ApiEndpointResolver.getArContactUrl(),
        })
      );
    }
  },
  getCustomerService(): Observable<{
    contacts: {
      contactType: string;
      phone: string;
      email: string;
      imageURL: string;
      name: string;
      extension?: string;
    }[];
  }> {
    if (ApiEndpointResolver.getEmployeeContactsUrl()) {
      return this.getEmployeeContacts().pipe(
        map((contacts: IEmployeeContact[]) => {
          return {
            contacts: contacts
              .filter(
                (c) =>
                  c.employeeContactRole === EmployeeContactRole.Csr ||
                  c.employeeContactRole === EmployeeContactRole.Sr
              )
              .map((contact) => {
                return {
                  name: contact.name,
                  email: contact.email,
                  phone: contact.phone,
                  imageURL: contact.imageUrl,
                  contactType:
                    contact.employeeContactRole === EmployeeContactRole.Csr
                      ? "PrimaryCSR"
                      : "",
                  extension: contact.extension,
                };
              }),
          };
        })
      );
    } else {
      return ApiCacheService.withCache(
        "CustomerServiceCSR",
        HttpClient.get({
          baseUri: ApiEndpointResolver.getCustomerServiceUrl(),
        })
      );
    }
  },
  getEmployeeContacts(): Observable<any> {
    return ApiCacheService.withCache(
      "EmployeeContacts",
      HttpClient.get({
        baseUri: ApiEndpointResolver.getEmployeeContactsUrl() || "",
      })
    );
  },
};
